import React from "react";
import {Card, CardContent, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {green, orange, red} from "@material-ui/core/colors";
import {SecondarySelect} from "../SecondarySelect";
import {AccountType} from "../../interfaces/Accounts";
import {Invoice} from "../../interfaces/invoice";
import {useSelector} from "react-redux";
import {CurrencyDisplay} from "../../common/CurrencyDisplay";
import {
    useInvoiceBalance,
    useInvoiceTotalCredits,
    useInvoiceTotalDue,
    useInvoiceTotalOverDue
} from "../../hooks/InvoiceHooks";
import {useIntl} from "react-intl";
import {useCurrencyKey} from "../../selectors/ConfigSelectors";
import {RootState} from "../../reducers/RootReducer";

const useStyles = makeStyles({
    due: {
        color: orange["500"],
    },
    pastdue: {
        color: red["500"],
    },
    credit: {
        color: green["500"],
    },
    title: {
        fontSize: "1em"
    },
    value: {
        fontSize: "1.1em"
    }
});


export function DashboardPage(props: {}) {
    
    return (<div className={"container"}>
        <div className={"row my-3"}>
            <div className={"col-12 col-md-3"}>
                <SecondarySelect accountType={AccountType.SoldTo}/>
            </div>
        </div>
        <DashboardDetails/>
    </div>)
}

export function DashboardDetails(){
    const classes = useStyles();
    const totalDue = useInvoiceTotalDue();
    const totalCredits = useInvoiceTotalCredits();
    const totalOverDue = useInvoiceTotalOverDue();
    const totalBalance = useInvoiceBalance();
    const intl = useIntl();
    const f = id => intl.formatMessage({id});
    const currency = useSelector<RootState, string>(state => state.default.selectedCurrencyOptionValue);

    return <div className={"row"}>
        <div className={"col-12 col-sm-6 col-md d-flex align-content-stretch"}>
            <Card elevation={0} className={"flex-fill"}>
                <CardContent>
                    <div className={"d-flex justify-content-between"}>
                        <Typography className={classes.title}>{f("dashboard.invoice_amount_due")}</Typography>
                    </div>
                    <div className={"d-flex justify-content-between"}>
                        <Typography className={`${classes.due} ${classes.value}`}><CurrencyDisplay currency={currency} value={totalDue}/></Typography>
                    </div>
                </CardContent>
            </Card>
        </div>
        <div className={"col-12 col-sm-6 col-md d-flex align-content-stretch mt-2 mt-sm-0"}>
            <Card elevation={0} className={"flex-fill"}>
                <CardContent>
                    <div className={"d-flex justify-content-between"}>
                        <Typography className={classes.title}>{f("dashboard.total_credits")}</Typography>
                    </div>
                    <div className={"d-flex justify-content-between"}>
                        <Typography className={`${classes.credit} ${classes.value}`}><CurrencyDisplay currency={currency} value={totalCredits}/></Typography>
                    </div>
                </CardContent>
            </Card>
        </div>
        <div className={"col-12 col-sm-6 col-md d-flex align-content-stretch mt-2 mt-sm-2 mt-md-0"}>
            <Card elevation={0} className={"flex-fill"}>
                <CardContent>
                    <div className={"d-flex justify-content-between"}>
                        <Typography className={classes.title}>{f("dashboard.balance")}</Typography>
                    </div>
                    <div className={"d-flex justify-content-between"}>
                        {totalBalance <= 0 && <Typography className={`${classes.credit} ${classes.value}`}><CurrencyDisplay currency={currency} value={totalBalance}/></Typography>}
                        {totalBalance > 0 && <Typography className={`${classes.due} ${classes.value}`}><CurrencyDisplay currency={currency} value={totalBalance}/></Typography>}
                    </div>
                </CardContent>
            </Card>
        </div>
        <div className={"col-12 col-sm-6 col-md d-flex align-content-stretch mt-2 mt-sm-2 mt-md-0"}>
            <Card elevation={0} className={"flex-fill"}>
                <CardContent>
                    <div className={"d-flex justify-content-between"}>
                        <div>
                            <Typography className={classes.title}>{f("dashboard.total_past_due")}</Typography>
                        </div>
                    </div>
                    <div className={"d-flex justify-content-between"}>
                        <Typography className={`${classes.pastdue} ${classes.value}`}><CurrencyDisplay currency={currency} value={totalOverDue}/></Typography>
                    </div>
                </CardContent>
            </Card>
        </div>
    </div>
}